import React, { useState } from "react"
import { Flex, Box, Text, Image } from "rebass"
import styled from "@emotion/styled"

import Flickity from "react-flickity-component"

import RowWrapper from "./RowWrapper"

const RowSlidesComponent = ({ data }) => {
  const { title, titleHeadingTag, text, justifyContent, slidesSlides } = data
  const [page, setPage] = useState(0)
  const [slider, setSlider] = useState(null)
  const paginate = direction => {
    direction === "next" ? slider.next() : slider.previous()
  }
  const sliderOptions = {
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    adaptiveHeight: true,
    on: {
      change: index => {
        setPage(index)
      },
    },
  }

  return (
    <RowWrapper {...data}>
      <Flex flexDirection="column" px={[0, null, null, 4]}>
        {title && text && (
          <Box as="header" flexDirection="column">
            {title && (
              <Text as={titleHeadingTag} mb={3} textAlign={justifyContent}>
                {title}
              </Text>
            )}
            {text && (
              <Box
                dangerouslySetInnerHTML={{ __html: text }}
                textAlign={justifyContent}
              />
            )}
          </Box>
        )}

        {slidesSlides && (
          <Box
            as={SliderContainer}
            width="100%"
            sx={{
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Flickity flickityRef={s => setSlider(s)} options={sliderOptions}>
              {slidesSlides.map((slide, index) => {
                return (
                  <Box as="blockquote" key={index} width="100%">
                    <Flex
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      width={["100%", null, null, "75%", "45%"]}
                      mx="auto"
                      fontFamily="heading"
                    >
                      {slide.iconImage && (
                        <Image src={slide.iconImage.sourceUrl} alt="slider icon" />
                      )}

                      {slide.text && (
                        <Text
                          lineHeight="1.461538462"
                          fontSize={["22px", null, 4]}
                          textAlign="center"
                          dangerouslySetInnerHTML={{ __html: slide.text }}
                        />
                      )}

                      {slide.title && (
                        <Text
                          as="cite"
                          fontSize={["18px", null, 2]}
                          fontStyle="normal"
                          textAlign="center"
                          dangerouslySetInnerHTML={{ __html: slide.title }}
                        />
                      )}
                    </Flex>
                  </Box>
                )
              })}
            </Flickity>

            <Box
              as={Arrow}
              sx={{ left: 0 }}
              aria-label="Témoignage précédent"
              onClick={() => paginate("previous")}
            >
              ←
            </Box>

            <Box
              as={Arrow}
              sx={{ right: 0 }}
              aria-label="Témoignage suivant"
              onClick={() => paginate("next")}
            >
              →
            </Box>

            <Flex
              alignItems="center"
              justifyContent="center"
              width="100%"
              mt={["22px", null, 4]}
            >
              {slidesSlides.map((slide, index) => {
                return (
                  <Box
                    key={index}
                    as={Dots}
                    disabled={index === page}
                    aria-label="dot"
                    onClick={() => setPage([index, index > page ? -1 : 1])}
                    sx={{
                      marginLeft: "2px",
                      marginRight: "2px",
                    }}
                  />
                )
              })}
            </Flex>
          </Box>
        )}
      </Flex>
    </RowWrapper>
  )
}

export default RowSlidesComponent

const SliderContainer = styled.div`
  .flickity-enabled {
    &:focus {
      outline: none;
    }
    .flickity-viewport {
      cursor: grab;
      &.is-pointer-down {
        cursor: grabbing;
      }
    }
  }
`

const Arrow = styled.button`
  position: absolute;
  top: 50%;
  font-family: ${props => props.theme.fonts.heading};
  background: none;
  border: 0;
  border-radius: 0;
  color: currentColor;
  display: block;
  font-size: 62px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  outline: none;
  opacity: 1;
  transition: opacity 250ms linear, color 250ms linear;
  transform: translateY(-50%);
  visibility: hidden;
  pointer-events: none;

  @media (min-width: ${props => props.theme.breakpoints[2]}) {
    visibility: visible;
    pointer-events: all;
    cursor: pointer;
  }

  &:hover,
  &:focus,
  &:active {
    color: ${props => props.theme.colors.secondary};
  }

  &[disabled] {
    opacity: 0.2;
    pointer-events: none;
  }
`
const Dots = styled.button`
  display: block;
  width: 14px;
  height: 14px;
  background: #fff;
  border: none;
  border-radius: 100%;
  margin: 0;
  padding: 0;
  outline: none;
  overflow: hidden;
  transform-origin: center center;
  transform: scale(0.5);
  transition: transform 250ms ease-out;
  will-change: transform;

  &[disabled] {
    transform: scale(1);
    background: ${props => props.theme.colors.secondary};
  }
`
